export const pathPerformanceDef = {
    chartType: 'spline',
    yAxis: [
        {
            title: {
                text: 'Hops',
            },
        },
    ],
    chartTrends: [
        {
            key: 'pathHops',
            value: 'avg',
            label: 'Hops',
            color: 'rgba(91, 163, 202, 1)',
            units: '',
            multiplier: 0,
        },
    ],
};
